import { Dimensions } from 'react-native';

export const screen = {
    height: Dimensions.get('window').height,
    width:  Dimensions.get('window').width
};